(function () {
  const moneyFormat = (window.theme && window.theme.moneyFormat) || "Rs. {{amount}}";
  const routes = (window.theme && window.theme.routes) || {
    cartAdd: "/cart/add",
    cartJs: "/cart.js",
    cartUpdate: "/cart/update.js",
    cartChange: "/cart/change.js",
    checkout: "/checkout"
  };

  function formatMoney(cents) {
    const value = (Number(cents) / 100).toFixed(2);
    if (typeof moneyFormat === "string" && moneyFormat.indexOf("{{amount}}") !== -1) {
      return moneyFormat.replace("{{amount}}", value).replace("{{amount_no_decimals}}", String(Math.round(cents / 100)));
    }
    return "Rs. " + value;
  }

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  async function fetchCart() {
    const res = await fetch(routes.cartJs || "/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  function cartEndpoint(path) {
    const base = path || "";
    return base.endsWith(".js") ? base : base + ".js";
  }

  async function clearCart() {
    const res = await fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" }
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || "Could not reset cart");
    }
    return res.json();
  }

  async function addToCart(id, quantity, properties) {
    const payload = { items: [{ id: Number(id), quantity: quantity || 1 }] };
    if (properties) payload.items[0].properties = properties;
    const res = await fetch(cartEndpoint(routes.cartAdd || "/cart/add"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || "Could not add to cart");
    }
    return res.json();
  }

  async function updateCart(data) {
    const res = await fetch(cartEndpoint(routes.cartUpdate || "/cart/update"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data)
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || "Could not update cart");
    }
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch(cartEndpoint(routes.cartChange || "/cart/change"), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    if (!res.ok) {
      const err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || "Could not update item");
    }
    return res.json();
  }

  function updateCartCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count || 0;
    });
  }

  function cartSavingsCents(cart) {
    let savings = 0;
    (cart.items || []).forEach(function (item) {
      const compareLine = (item.original_price || 0) * item.quantity;
      if (compareLine > item.final_line_price) {
        savings += compareLine - item.final_line_price;
      }
    });
    if (cart.total_discount) savings += cart.total_discount;
    return savings;
  }

  function renderDrawer(cart) {
    const root = document.querySelector("[data-cart-drawer]");
    if (!root) return;
    const itemsEl = root.querySelector("[data-cart-items]");
    const emptyEl = root.querySelector("[data-cart-empty]");
    const footerEl = root.querySelector("[data-cart-footer]");
    const subtotalEl = root.querySelector("[data-cart-subtotal]");
    const headerCountEl = root.querySelector("[data-cart-header-count]");
    const savingsRowEl = root.querySelector("[data-cart-savings-row]");
    const savingsEl = root.querySelector("[data-cart-savings]");

    if (!cart || !cart.items || cart.items.length === 0) {
      if (itemsEl) itemsEl.innerHTML = "";
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      if (headerCountEl) headerCountEl.textContent = "";
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (headerCountEl) {
      headerCountEl.textContent = "• " + cart.item_count + (cart.item_count === 1 ? " item" : " items");
    }

    const savings = cartSavingsCents(cart);
    if (savingsRowEl && savingsEl) {
      if (savings > 0) {
        savingsRowEl.hidden = false;
        savingsEl.textContent = "− " + formatMoney(savings);
      } else {
        savingsRowEl.hidden = true;
      }
    }

    if (itemsEl) {
      itemsEl.innerHTML = cart.items.map(function (item) {
        const hasCompare = item.original_price && item.original_price > item.final_price;
        const priceMarkup = hasCompare
          ? '<s>' + formatMoney(item.original_price * item.quantity) + '</s><strong>' + formatMoney(item.final_line_price) + '</strong>'
          : '<strong>' + formatMoney(item.final_line_price) + '</strong>';
        return (
          '<article class="drawer-item" data-line-key="' + escapeHtml(item.key) + '">' +
            '<img src="' + (item.image || "") + '" alt="">' +
            '<div class="drawer-item__body">' +
              '<div class="drawer-item__head">' +
                '<h3>' + escapeHtml(item.product_title) + '</h3>' +
                '<button type="button" class="drawer-item__remove" data-cart-remove aria-label="Remove item">' +
                  '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 7h16"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><path d="M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/><path d="M10 11v6M14 11v6"/></svg>' +
                '</button>' +
              '</div>' +
              (item.variant_title ? '<p class="drawer-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
              '<div class="drawer-item__footer">' +
                '<div class="qty-stepper" data-qty-stepper>' +
                  '<button type="button" data-qty-decrease aria-label="Decrease quantity">−</button>' +
                  '<span data-qty-value>' + item.quantity + '</span>' +
                  '<button type="button" data-qty-increase aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<div class="drawer-item__price">' + priceMarkup + '</div>' +
              '</div>' +
            '</div>' +
          '</article>'
        );
      }).join("");
    }
  }

  function openDrawer() {
    const root = document.querySelector("[data-cart-drawer]");
    if (root) root.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    const root = document.querySelector("[data-cart-drawer]");
    if (root) root.hidden = true;
    document.body.style.overflow = "";
  }

  let drawerBusy = false;
  function applyLineChange(key, quantity) {
    if (drawerBusy) return;
    drawerBusy = true;
    const root = document.querySelector("[data-cart-drawer]");
    if (root) root.classList.add("is-updating");
    changeLine(key, quantity)
      .then(function (cart) {
        updateCartCount(cart);
        renderDrawer(cart);
      })
      .catch(function (err) {
        alert(err.message);
      })
      .finally(function () {
        drawerBusy = false;
        if (root) root.classList.remove("is-updating");
      });
  }

  document.addEventListener("click", function (e) {
    const toggle = e.target.closest("[data-menu-toggle]");
    if (toggle) {
      const nav = document.querySelector("[data-mobile-nav]");
      if (nav) {
        nav.hidden = !nav.hidden;
        document.body.style.overflow = nav.hidden ? "" : "hidden";
      }
    }
    const mobileNav = document.querySelector("[data-mobile-nav]");
    if (mobileNav && !mobileNav.hidden && e.target === mobileNav) {
      mobileNav.hidden = true;
      document.body.style.overflow = "";
    }
    if (e.target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      fetchCart().then(function (cart) {
        renderDrawer(cart);
        openDrawer();
      });
    }
    if (e.target.closest("[data-cart-close]")) closeDrawer();

    const quick = e.target.closest("[data-quick-add]");
    if (quick) {
      e.preventDefault();
      e.stopPropagation();
      const btn = quick;
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding...";
      addToCart(btn.dataset.variantId, 1)
        .then(fetchCart)
        .then(function (cart) {
          updateCartCount(cart);
          renderDrawer(cart);
          if (window.theme && window.theme.cartDrawer) openDrawer();
          btn.textContent = "Added ✓";
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1000);
        })
        .catch(function (err) {
          alert(err.message);
          btn.textContent = original;
          btn.disabled = false;
        });
    }

    const qtyIncrease = e.target.closest("[data-qty-increase]");
    const qtyDecrease = e.target.closest("[data-qty-decrease]");
    const removeBtn = e.target.closest("[data-cart-remove]");
    if (qtyIncrease || qtyDecrease || removeBtn) {
      e.preventDefault();
      const article = e.target.closest("[data-line-key]");
      if (!article) return;
      const key = article.dataset.lineKey;
      const valueEl = article.querySelector("[data-qty-value]");
      const currentQty = valueEl ? parseInt(valueEl.textContent, 10) || 1 : 1;
      if (removeBtn) {
        applyLineChange(key, 0);
      } else if (qtyIncrease) {
        applyLineChange(key, currentQty + 1);
      } else if (qtyDecrease) {
        applyLineChange(key, Math.max(0, currentQty - 1));
      }
    }
  });

  /* Mobile category horizontal scroll feels smoother with drag */
  document.querySelectorAll("[data-category-scroll]").forEach(function (track) {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    track.addEventListener("pointerdown", function (e) {
      if (window.matchMedia("(max-width: 990px)").matches === false) return;
      isDown = true;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener("pointermove", function (e) {
      if (!isDown) return;
      track.scrollLeft = scrollLeft - (e.clientX - startX);
    });
    track.addEventListener("pointerup", function () { isDown = false; });
    track.addEventListener("pointercancel", function () { isDown = false; });
  });

  window.MyStoreCart = {
    formatMoney: formatMoney,
    fetchCart: fetchCart,
    clearCart: clearCart,
    addToCart: addToCart,
    updateCart: updateCart,
    changeLine: changeLine,
    updateCartCount: updateCartCount,
    renderDrawer: renderDrawer,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };
})();
